import { useState, useEffect } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_CONFIG_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_CONFIG_API_BASE_URL;

export default function useConfigurationBatchSettings() {
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [batchSettings, setBatchSettings] = useState([]);
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    useEffect(async () => {
        if (account && instance) {
            await executeRequest();
        }
    }, [account, instance]);

    const executeRequest = async () => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        setBatchSettings([]);

        try {
            const { data } = await getAuthenticatedClient({
                url: `${BASE_URL}/configurations/search`,
                method: 'POST',
                account,
                msalInstance: instance,
                body: {
                    ruleType: 'EqualsUsersMRPPortalClient',
                    configurationType: 'BatchInputSettings'
                }
            });
            
            setBatchSettings(data.value.columns);
            
        } catch (e) {
            console.error(e);
            setError(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        success,
        error,
        batchSettings,
        refresh: executeRequest
    };
}
